import { newDirectoryGroupAccesses } from "@p0security/shared/integrations/directories/accesses";
import { groupOnlyFilters } from "@p0security/shared/integrations/directories/filters";
import { registerIntegration } from "@p0security/shared/integrations/registry";
import { Registration } from "@p0security/shared/integrations/types";

export const GoogleWorkspaceRegistration = Registration({
  accesses: newDirectoryGroupAccesses("beta"),
  category: "directory",
  components: "oauth",
  docs: { install: "google-workspace" },
  filters: groupOnlyFilters,
  label: "Google Workspace",
  logoUrl:
    "https://fonts.gstatic.com/s/i/productlogos/admin_2020q4/v6/192px.svg",
  maturity: "ga",
  requestType: "requestable",
  useMapping: [],
});

registerIntegration("workspace", GoogleWorkspaceRegistration);
